import { IBEError } from '@common/interfaces/be-error.interface';
import { useCallback, useState } from 'react';

interface IReturn<T> {
    start: (promises: Promise<unknown>[]) => void;
    loading: boolean;
    errors: IBEError[] | undefined;
    success: boolean;
    data: T | undefined;
    reset: () => void;
}
export function usePromise<T>(): IReturn<T> {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [data, setData] = useState<T | undefined>(undefined);
    const [errors, setErrors] = useState<IBEError[] | undefined>();
    return {
        start: useCallback((promise: Promise<unknown>[]): void => {
            setErrors(undefined);
            setSuccess(false);
            setLoading(true);
            Promise.all(promise)
                .then((result) => {
                    setData(result as unknown as T);
                    setSuccess(true);
                })
                .catch((error) => {
                    setErrors((prev): IBEError[] | undefined => {
                        if (prev) {
                            return [...prev, error];
                        }
                        return [error];
                    });
                })
                .finally(() => {
                    setLoading(false);
                });
        }, []),
        reset: useCallback(() => {
            setErrors(undefined);
            setSuccess(false);
            setLoading(false);
        }, []),
        errors,
        success,
        data,
        loading,
    };
}
